import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { getInsertionOrderBudgetAndSpendContentConfig } from '../../utils/top-key-card';
import { AmountNode, InsertionOrderItem } from './content-item-node';

export function InsertionOrderBudgetAndSpendCard({
  i18n, currencyCode, rawData,
}) {
  const items = getInsertionOrderBudgetAndSpendContentConfig();
  return (
    <div>
      {_.compact(_.map(items, item => _.isNumber(rawData[item.fieldName]) && (
        <InsertionOrderItem
          key={`insertion-order-item-${item.key}`}
          i18n={i18n}
          itemName={item.fieldName}
          itemKey={item.key}
          itemValue={(
            <AmountNode
              i18n={i18n}
              currencyCode={currencyCode}
              amount={rawData[item.fieldName]}
            />
          )}
        />)))}
    </div>
  );
}

InsertionOrderBudgetAndSpendCard.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  currencyCode: PropTypes.string.isRequired,
  rawData: PropTypes.shape({}).isRequired,
};

